<template>
  <div class="">
    <Form ref="form" :model="model" :label-width="100">
      <Form-item prop="role" label="角色">
        <Select v-model="model.role" filterable clearable>
          <Option v-for="(role, key) in roles" :value="key" :key="key" :label="role"></Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSubmit('form')" long>保存</Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import { ViewMember, UpdateMember, GetAssistItems } from '@/api/study.team'

export default {
  name: 'edit-member',
  data: function () {
    return {
      model: {
        id: '',
        role: '',
        user_id: '',
        name: ''
      },
      roles: {},
      loading: false
    }
  },
  created: function () {
    this.getItems()
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      ViewMember(id).then(async res => {
        this.model = res
        this.model.role = res.role
      })
    },
    handleSubmit: function (name) {
      this.postForm()
    },
    postForm: function () {
      UpdateMember(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$Message.success('修改成功')
          this.$emit('refresh')
        }
      })
    },
    getItems: function () {
      const id = this.$route.params.id
      GetAssistItems(id).then(async res => {
        this.roles = res.roles
      })
    }
  }
}
</script>
